export default {
  BY_ID: 'byId',
  ALL_IDS: 'allIds',
}
